<template>
  <!-- Change viewBox and fill params -->
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 32 32"
  >
    <g :fill="color" :stroke="color" class="fill-current stroke-current">
      <path
        fill="#fff"
        d="M32 16c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z"
      />
      <path
        fill="#09104a"
        d="M11.85 22.059h-3.178v-10.227h3.178zM10.259 10.437c-0.002 0-0.005 0-0.008 0-1.021 0-1.848-0.827-1.848-1.848s0.827-1.848 1.848-1.848c1.018 0 1.843 0.823 1.848 1.84v0c0 0.001 0 0.001 0 0.002 0 1.019-0.822 1.846-1.839 1.854h-0.001zM23.739 22.059h-3.171v-4.978c0-1.187-0.024-2.709-1.651-2.709s-1.904 1.29-1.904 2.622v5.064h-3.174v-10.227h3.040v1.395h0.045c0.59-0.996 1.659-1.654 2.882-1.654 0.047 0 0.094 0.001 0.141 0.003l-0.007-0c3.214 0 3.806 2.117 3.806 4.866v5.618z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    }
  }
}
</script>
